import { c as _c } from "react-compiler-runtime";
import { useEffect, useState } from 'react';
import { createCollaborationSidebarStateFollower } from './collaborationSidebarState';
export const useCollaborationSidebarFollowerStore = () => {
  "use memo";

  const $ = _c(3);
  const [follower] = useState(_temp);
  let t0;
  let t1;
  if ($[0] !== follower) {
    t0 = () => () => {
      follower.cleanup();
    };
    t1 = [follower];
    $[0] = follower;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return follower;
};
function _temp() {
  return createCollaborationSidebarStateFollower();
}